import React from 'react'
import { Link } from 'react-router-dom'

export default function ServiceFast() {
  return (
    <>
      <section className="service-fast-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 order-2 order-lg-1 order-md-1">
              <div className="service-fast-box">
                <img src="/assets/images/service-fast-1.webp" alt="Fast" className="img-responsive" />
                <div>
                  <span>Same Visit Repairs</span>
                  <p>We diagnose and fix issues in the same visit, minimizing downtime and avoiding repeat callouts.</p>
                </div>
              </div>
              <div className="service-fast-box">
                <img src="/assets/images/service-fast-2.webp" alt="Fast" className="img-responsive" />
                <div>
                  <span>Equipment-Specific Engineers </span>
                  <p>Technicians trained on specific brands and models, reducing diagnostic time and avoiding repeat visits.</p>
                </div>
              </div>
              <div className="service-fast-box">
                <img src="/assets/images/service-fast-3.webp" alt="Fast" className="img-responsive" />
                <div>
                  <span>Stocked For Your Equipment</span>
                  <p>We carry common parts for the machines we service, ensuring repairs are completed on the same day.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 order-1 order-lg-2 order-md-2">
              <div className="service-fast-content">
                <small className='gradient-color'>Why Choose Supershine for Service</small>
                <h2 className='heading'>We Know These Machines. We Built The Network Around Them.</h2>
                <p>Most service providers arrive, look at the machine, and order parts. Supershine technicians arrive with the right parts already loaded, because we know what fails, how it fails, and what your specific model needs before we walk through the door.</p>
                <Link to={"/contact"} className="default-btn"> <span>Book A Service Visit</span>  </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
